import { ArchivedFilter } from "@avenueops/shared-types";
import { DropdownSelect } from "@avenueops/web-components";
import {
  ArchiveBoxIcon,
  ChevronDownIcon,
  SignalIcon,
  Squares2X2Icon,
  ViewfinderCircleIcon,
  ChevronUpDownIcon,
  BookmarkIcon,
} from "@heroicons/react/24/outline";
import { ProcessView } from "@prisma/client";
import * as DropdownMenu from "@radix-ui/react-dropdown-menu";
import Link from "next/link";
import { useRouter } from "next/router";
import { ComponentType } from "react";
import { pagesPath } from "utils/$path";
import { trpc } from "utils/trpc";
import { v4 as uuidv4 } from "uuid";

interface Props {
  archived: ArchivedFilter;
  signalView?: ProcessView;
  isDashboard: boolean;
}

export default function PageTitle({ archived, signalView, isDashboard }: Props): JSX.Element {
  const isArchived = archived === ArchivedFilter.Enum.ARCHIVED;
  const { data: signalViews, isLoading } = trpc.processViews.list.useQuery();
  const options = [
    { label: "Signals", value: "__SIGNALS__", icon: <SignalIcon className="h-6 w-6" /> },
    ...(signalViews?.map((view) => ({
      label: view.title,
      value: view.id,
      icon: <BookmarkIcon className="h-5 w-5" />,
    })) ?? []),
  ];

  const title = signalView?.title ?? "Signals";
  const router = useRouter();

  return isDashboard ? (
    <StaticHeader title="My Dashboard" Icon={Squares2X2Icon} />
  ) : isArchived ? (
    <StaticHeader title="Archived" Icon={ArchiveBoxIcon} />
  ) : isLoading || !signalViews || signalViews.length === 0 ? (
    <StaticHeader title={title} Icon={SignalIcon} />
  ) : (
    <div className=" flex flex-row items-center gap-2 pr-2 text-gray-950 w-fit">
      <DropdownSelect
        name="signalPageTitle"
        type="BUTTON"
        options={options ?? []}
        selectedValue={signalView?.id ?? "__SIGNALS__"}
        disableUnselect
        onChange={(value) => {
          !value ? {} : value === "__SIGNALS__" ? router.push("/signals") : router.push(`/signal-views/${value}`);
        }}
      />
    </div>
  );
}

interface StaticHeaderProps {
  title: string;
  Icon?: React.FC<any>;
}

function StaticHeader({ title, Icon }: StaticHeaderProps) {
  return (
    <div className="flex flex-row gap-3 justify-center items-center appearance-none w-fit h-full whitespace-nowrap p-2 text-gray-950">
      {Icon ? <Icon className="h-5 w-5" /> : null}
      <span>{title}</span>
    </div>
  );
}
